import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const WEBHOOK_CATEGORIES_QUERY_KEY = 'webhook-categories';

const getWebhookCategoriesQueryOptions = () =>
  queryOptions({
    queryKey: [WEBHOOK_CATEGORIES_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.notifications.webhookCategories();
      // The "All" category must always be the first option,
      // the remaining categories keep their original API order
      return data.categories?.toSorted((a, b) => {
        if (a.name === 'All') return -1;
        if (b.name === 'All') return 1;
        return 0;
      });
    },
  });

export const useGetWebhookCategoriesQuery = () => {
  const {
    data: categories,
    isLoading,
    error,
    refetch,
  } = useQuery(getWebhookCategoriesQueryOptions());
  return {
    categories,
    isLoading,
    error,
    refetch,
  };
};
